import { ref, onMounted } from 'vue';
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array-buffer.detached.js";
import "core-js/modules/es.array-buffer.transfer.js";
import "core-js/modules/es.array-buffer.transfer-to-fixed-length.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.every.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.typed-array.at.js";
import "core-js/modules/es.typed-array.find-last.js";
import "core-js/modules/es.typed-array.find-last-index.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.to-reversed.js";
import "core-js/modules/es.typed-array.to-sorted.js";
import "core-js/modules/es.typed-array.with.js";
import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0bb890ea"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "text"
}, "请上传谷歌《earning report》收入报告", -1));
const _hoisted_3 = ["onMouseover"];
const _hoisted_4 = {
  key: 1
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "text"
}, "请上传IOS《financial_report》付款信息报告", -1));
const _hoisted_6 = ["onMouseover"];
const _hoisted_7 = {
  class: "mybtnsModel"
};
import axios from 'axios';
import { postCvsUpload, postBillAdd, postNickNameList, getPreSignedUrl, getFileDetail } from '@/api/thirdParty';
import { OK } from '@/common';
import { message } from 'ant-design-vue';
import { useStore } from '@/store';
export default /*#__PURE__*/_defineComponent({
  __name: 'BillModal',
  props: {
    modelVisible: {
      default: false,
      type: Boolean
    }
  },
  emits: ['update:modelVisible'],
  setup(__props, {
    emit
  }) {
    const nickNameList = ref([]);
    const taskTypeChange = () => {
      formState.value.accountId = [];
      fileList.value = [];
    };
    // const labelCol = { style: { width: '125px' } };
    const formRef = ref();
    const formState = ref({
      taskType: 0,
      accountId: []
    });
    const fileList = ref([]);
    const isLoading = ref(0);
    const preSignedUrl = ref('');
    const remoteFileName = ref('');
    const closeModal = () => {
      emit('update:modelVisible', false);
      formRef.value.resetFields();
      fileList.value = [];
    };
    const isFileEncrypted = (file, callback) => {
      const reader = new FileReader();
      reader.onload = e => {
        var _e$target;
        const bytes = new Uint8Array((_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.result);
        // 检查前10个字节是否都是可打印字符
        // ASCII 可打印字符范围：32-126，加上常见的控制字符：9(tab),10(换行),13(回车)
        const isPrintable = bytes.every(byte => byte >= 32 && byte <= 126 ||
        // 可打印字符
        byte === 9 || byte === 10 || byte === 13 ||
        // 制表符、换行符、回车符
        byte === 0xef || byte === 0xbb || byte === 0xbf);
        callback(!isPrintable);
      };
      reader.onerror = () => {
        callback(false);
      };
      // 读取前10个字节
      reader.readAsArrayBuffer(file.slice(0, 10));
    };
    const isCsvFile = file => {
      var _file$file;
      return (_file$file = file.file) === null || _file$file === void 0 ? void 0 : _file$file.name.includes('.csv');
    };
    const uploadCSV = async (file, callback) => {
      var _JSON$parse;
      const formData = new FormData();
      formData.append('accessAttribute', '1');
      formData.append('businessId', (_JSON$parse = JSON.parse(useStore().userInfo)) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.id);
      formData.append('businessType', 'THIRD_BILL_GP');
      formData.append('file', file.file);
      isLoading.value++;
      try {
        const response = await postCvsUpload(formData);
        if (response.code === OK) {
          callback(response.data);
          message.success(response.msg);
        }
      } catch (e) {}
      isLoading.value--;
    };
    const queryUploadInfo = async (file, fileName, callback) => {
      try {
        const response = await getFileDetail({
          remoteFileName: remoteFileName.value,
          accessAttribute: 1,
          businessType: 'THIRD_BILL_GP'
        });
        if (response.code === '0') {
          response.data.originalFilename = fileName;
          callback(response.data);
          message.success(response.msg);
        }
      } catch (e) {}
      isLoading.value--;
    };
    const customRequestGP = file => {
      if (!isCsvFile(file)) {
        return message.error('请上传csv格式文件');
      }
      isFileEncrypted(file.file, async isEncrypted => {
        if (isEncrypted) {
          return message.error('文件已加密，请解密后上传');
        } else {
          try {
            isLoading.value++;
            const fileName = file.file.name;
            // 1. 获取预上传文件地址
            const res = await getPreSignedUrl({
              fileName: fileName,
              accessAttribute: 1,
              businessType: 'THIRD_BILL_GP'
            });
            if (res && res.code == '0') {
              preSignedUrl.value = res.data.preSignedUrl;
              remoteFileName.value = res.data.remoteFileName;
            }
            // 2. 上传文件到 MinIO
            await axios.put(preSignedUrl.value, file.file, {
              headers: {
                'Content-Type': file.file.type
              }
            });
            // 3. 调用第三步接口
            queryUploadInfo(file, fileName, data => {
              fileList.value.push(data);
            });
          } catch {
            message.error('文件上传minIO失败');
            isLoading.value--;
          }
        }
      });
    };
    const customRequestIOS = file => {
      if (!isCsvFile(file)) {
        return message.error('请上传csv格式文件');
      }
      isFileEncrypted(file.file, async isEncrypted => {
        if (isEncrypted) {
          return message.error('文件已加密，请解密后上传');
        } else {
          uploadCSV(file, data => {
            if (fileList.value.length == 1) {
              fileList.value.splice(0, 1, data);
            } else {
              fileList.value.push(data);
            }
          });
        }
      });
    };
    const filterOption = (input, option) => {
      return option.accountName.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    };
    const deleteFile = index => {
      fileList.value.splice(index, 1);
    };
    const postOnSubmit = async param => {
      try {
        const {
          code,
          msg
        } = await postBillAdd(param);
        if (code === OK) {
          //刷新任务列表
          message.success(msg);
          closeModal();
        }
      } catch (e) {}
    };
    const onSubmitIos = () => {
      if (!formState.value.accountId.length) {
        return message.info('请选择发布账号');
      }
      const param = {
        list: formState.value.accountId.map(item => {
          return {
            reqParams: {
              fileUrl: fileList.value[0].fileUrl,
              accountId: item
            },
            taskType: formState.value.taskType,
            taskName: fileList.value[0].originalFilename
          };
        })
      };
      postOnSubmit(param);
    };
    const onSubmitGP = () => {
      const param = {
        list: fileList.value.map(item => {
          return {
            reqParams: {
              fileUrl: item.fileUrl
            },
            taskType: formState.value.taskType,
            taskName: item.originalFilename
          };
        })
      };
      postOnSubmit(param);
    };
    const onSubmit = async () => {
      if (isLoading.value) {
        return message.info('文件上传中，请稍后提交');
      }
      if (!fileList.value.length) {
        return message.info('请上传文件');
      }
      if (formState.value.taskType == 0) {
        onSubmitGP();
      }
      if (formState.value.taskType == 10) {
        onSubmitIos();
      }
    };
    const delIndex = ref(-1);
    const showIcon = index => {
      delIndex.value = index;
    };
    const hideIcon = () => {
      delIndex.value = -1;
    };
    const getNickNameList = async () => {
      const param = {
        accountType: 2,
        accountName: '',
        pageNum: 1,
        pageSize: 1000,
        notBlankFieldList: ['vendorNum'] // 页大小 填 1000
      };
      try {
        const {
          code,
          data
        } = await postNickNameList(param);
        if (code === OK) {
          nickNameList.value = data.list;
        }
      } catch (e) {}
    };
    onMounted(() => {
      getNickNameList();
      // queryPreUrl()
    });
    return (_ctx, _cache) => {
      const _component_a_radio = _resolveComponent("a-radio");
      const _component_a_radio_group = _resolveComponent("a-radio-group");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_upload = _resolveComponent("a-upload");
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_form = _resolveComponent("a-form");
      const _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createBlock(_component_a_modal, {
        title: "导入账单",
        onCancel: closeModal,
        open: __props.modelVisible,
        width: "541px",
        centered: "",
        footer: false,
        maskClosable: false
      }, {
        default: _withCtx(() => [_createVNode(_component_a_form, {
          ref_key: "formRef",
          ref: formRef,
          model: formState.value,
          labelAlign: "right",
          class: "form"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_form_item, {
            label: "渠道",
            required: "",
            name: "taskType"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_radio_group, {
              value: formState.value.taskType,
              "onUpdate:value": _cache[0] || (_cache[0] = $event => formState.value.taskType = $event),
              name: "radioGroup",
              onChange: taskTypeChange
            }, {
              default: _withCtx(() => [_createVNode(_component_a_radio, {
                value: 0
              }, {
                default: _withCtx(() => [_createTextVNode("GP")]),
                _: 1
              })]),
              _: 1
            }, 8, ["value"])]),
            _: 1
          }), formState.value.taskType == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_a_form_item, {
            label: "文件",
            required: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_a_upload, {
              multiple: true,
              "show-upload-list": false,
              customRequest: customRequestGP
            }, {
              default: _withCtx(() => [_createVNode(_component_a_button, {
                class: "borderBlue"
              }, {
                default: _withCtx(() => [_createVNode(_component_svg_icon, {
                  "icon-class": "upload_stencil",
                  "class-name": "mark-icon"
                }), _createTextVNode(" 点击上传 ")]),
                _: 1
              })]),
              _: 1
            }), _hoisted_2, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fileList.value, (item, index) => {
              return _openBlock(), _createElementBlock("div", {
                class: "file-list",
                key: item.originalFilename,
                onMouseover: $event => showIcon(index),
                onMouseout: _cache[1] || (_cache[1] = $event => hideIcon())
              }, [_createVNode(_component_svg_icon, {
                "icon-class": "file",
                class: "file"
              }), _createElementVNode("div", null, _toDisplayString(item.originalFilename), 1), _withDirectives(_createVNode(_component_svg_icon, {
                "icon-class": "success_2",
                class: "delete"
              }, null, 512), [[_vShow, index !== delIndex.value]]), _withDirectives(_createVNode(_component_svg_icon, {
                "icon-class": "cha",
                class: "delete",
                onClick: $event => deleteFile(index)
              }, null, 8, ["onClick"]), [[_vShow, index === delIndex.value]])], 40, _hoisted_3);
            }), 128))]),
            _: 1
          })])) : _createCommentVNode("", true), formState.value.taskType == 10 ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_a_form_item, {
            label: "账号",
            required: "",
            name: "accountId"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_select, {
              style: {
                "width": "200px"
              },
              placeholder: "请选择账号",
              mode: "multiple",
              fieldNames: {
                label: 'accountName',
                value: 'accountId'
              },
              "filter-option": filterOption,
              options: nickNameList.value,
              value: formState.value.accountId,
              "onUpdate:value": _cache[2] || (_cache[2] = $event => formState.value.accountId = $event)
            }, null, 8, ["options", "value"])]),
            _: 1
          }), _createVNode(_component_a_form_item, {
            label: "文件",
            required: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_a_upload, {
              "show-upload-list": false,
              customRequest: customRequestIOS
            }, {
              default: _withCtx(() => [_createVNode(_component_a_button, {
                class: "borderBlue"
              }, {
                default: _withCtx(() => [_createVNode(_component_svg_icon, {
                  "icon-class": "upload_stencil",
                  "class-name": "mark-icon"
                }), _createTextVNode(" 点击上传 ")]),
                _: 1
              })]),
              _: 1
            }), _hoisted_5, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fileList.value, (item, index) => {
              return _openBlock(), _createElementBlock("div", {
                class: "file-list",
                key: item.originalFilename,
                onMouseover: $event => showIcon(index),
                onMouseout: _cache[3] || (_cache[3] = $event => hideIcon())
              }, [_createVNode(_component_svg_icon, {
                "icon-class": "file",
                class: "file"
              }), _createElementVNode("div", null, _toDisplayString(item.originalFilename), 1), _withDirectives(_createVNode(_component_svg_icon, {
                "icon-class": "success_2",
                class: "delete"
              }, null, 512), [[_vShow, index !== delIndex.value]]), _withDirectives(_createVNode(_component_svg_icon, {
                "icon-class": "cha",
                class: "delete",
                onClick: $event => deleteFile(index)
              }, null, 8, ["onClick"]), [[_vShow, index === delIndex.value]])], 40, _hoisted_6);
            }), 128))]),
            _: 1
          })])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_7, [_createVNode(_component_a_button, {
            style: {
              "margin-right": "8px"
            },
            class: "myGray",
            onClick: closeModal
          }, {
            default: _withCtx(() => [_createTextVNode("取消")]),
            _: 1
          }), _createVNode(_component_a_button, {
            type: "primary",
            loading: Boolean(isLoading.value),
            onClick: onSubmit
          }, {
            default: _withCtx(() => [_createTextVNode("提交")]),
            _: 1
          }, 8, ["loading"])])]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["open"]);
    };
  }
});